import { blockAnimations } from './scripts/blockAnimations'
import { axios_mailChimpSubscribe } from './scripts/axios_mailChimpSubscribe'
import { sideButtonsScroller } from './scripts/sideButtonsScroller'
import { headerScroller } from './scripts/headerScroller'
import { headerMenu } from './scripts/headerMenu'
import { engageAllInlineGallerySliders } from './scripts/inlineGallerySlider'
import { massHookGalleries } from './scripts/gallerySlider'
import { axios_requestNewPosts } from './scripts/axios_requestNewPosts'
import { globals } from '@/src/globals'
import { engageAllSliders } from './scripts/bannerSlider'

import * as styles from './styles/index.scss'
import { axios_requestNewGalleries } from './scripts/axios_requestNewGalleries'
import { woo_appendButtonsThankYouPage, woo_changeMiniCart, woo_changeMiniCartCounter, woo_replaceButtonText } from './scripts/wooTweaks'
// import renderer from './renderer/index.pug'

// Main file
const nevimaGroup = (input: any): void => {
  const processedStyles = styles

  globals.externalInput = input

  blockAnimations()

  headerMenu()
  headerScroller()

  sideButtonsScroller()

  engageAllSliders()
  engageAllInlineGallerySliders()

  axios_requestNewPosts()
  axios_requestNewGalleries()

  axios_mailChimpSubscribe()

  woo_replaceButtonText()

  setTimeout(() => {
    woo_appendButtonsThankYouPage()
    woo_changeMiniCartCounter()
  }, 1000)

  setInterval(() => {
    woo_changeMiniCart()
    woo_changeMiniCartCounter()
  }, 2000)

  const galleryList = document.querySelectorAll('.js-singleGallery') as unknown as HTMLElement[]
  massHookGalleries(galleryList)
}

export default nevimaGroup
